import { Minus, Plus } from 'lucide-react';

type TallyCountStepperProps = {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  min?: number;
  inputId?: string;
};

export function TallyCountStepper({
  value,
  onChange,
  disabled = false,
  min = 1,
  inputId,
}: Readonly<TallyCountStepperProps>) {
  const handleTextChange = (raw: string) => {
    const parsed = Math.round(parseFloat(raw));
    if (!Number.isFinite(parsed)) return;
    onChange(Math.max(min, parsed));
  };

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        data-testid="tally-count-stepper-decrement"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={disabled || value <= min}
        className="w-7 h-7 rounded border border-neut-300 flex items-center justify-center hover:bg-neut-50 transition-colors text-neut-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Minus size={14} aria-hidden="true" />
      </button>
      <input
        type="number"
        id={inputId}
        data-testid="tally-count-stepper-input"
        value={value}
        min={min}
        step={1}
        disabled={disabled}
        onChange={(e) => handleTextChange(e.target.value)}
        className="w-14 h-7 text-center text-sm font-semibold text-neut-900 border border-neut-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none disabled:opacity-50"
      />
      <button
        type="button"
        data-testid="tally-count-stepper-increment"
        onClick={() => onChange(value + 1)}
        disabled={disabled}
        className="w-7 h-7 rounded border border-neut-300 flex items-center justify-center hover:bg-neut-50 transition-colors text-neut-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Plus size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
